function getPrecisePercentage(number: number): string {
  const isFloat = number - Math.round(number) !== 0;

  return `${isFloat ? number.toFixed(2) : number}%`;
}

export default getPrecisePercentage;
